import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhone,faShoppingBasket,faEnvelope} from "@fortawesome/pro-regular-svg-icons";
import {useAppContext} from "../../../context/AppContext";


function Navbar(props) {
    const {setCurrentPage} = useAppContext()

    return (
        <nav className=" drop-shadow-lg border-b border-gray-300 bg-[#192124] max-w-[100vw] py-2 no-print">
            <div className="container mx-auto flex flex-col-reverse sm:flex-row items-center justify-between">
                <a href="https://www.rhinodoor.co.uk" target="_blank" rel="noopener noreferrer" className="">
                    <img width={300} height="auto" className="max-w-xl px-4 w-[200px] h-auto lg:w-[300px] lg:h-[100px] object-contain" src="/assets/logo.png" alt='logo'/>
                </a>
                <div className='flex items-center gap-6'>
                    <div className="flex flex-col">
                        <a className='text-primary flex items-center gap-2' href="tel:01843446679">
                            <FontAwesomeIcon className='text-primary' icon={faPhone}/>
                            <span className='text-white text-sm'>01843446679</span>
                        </a>
                        <a className='text-primary flex items-center gap-2' href="mailto:hello@rhinodoor.co.uk ">
                            <FontAwesomeIcon className='text-primary' icon={faEnvelope}/>
                            <span className='text-white text-sm'>hello@rhinodoor.co.uk</span>
                        </a>
                    </div>
                    <button className='bg-white size-10 rounded-full' onClick={() => setCurrentPage('basket')}>
                        <FontAwesomeIcon className='text-primary text-xl' icon={faShoppingBasket}/>
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
